import * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
} from '@gitbook/spine-react';

import type { ChangeRequestsListFilterState } from './ChangeRequestsListFilters';

/**
 * Empty state for the change requests list.
 */
export function ChangeRequestsListEmptyState(props: {
    filters: ChangeRequestsListFilterState;
    onFiltersChange: (filters: ChangeRequestsListFilterState) => void;
}) {
    const { filters, onFiltersChange } = props;

    return (
        <div className="flex flex-1 flex-col gap-3">
            <EmptyState>
                <EmptyStateIcon>
                    <Icon.ChangeRequest />
                </EmptyStateIcon>
                {filters?.contributor ||
                filters?.space ||
                filters?.creator ||
                filters?.requestedReview ||
                filters?.conversationsIssuesCluster ? (
                    <>
                        <Description>No change requests match the filters.</Description>
                        <EmptyStateActions>
                            <Button
                                kind="link"
                                size="small"
                                label="Clear filters"
                                leadingIcon={Icon.X}
                                onPress={() => {
                                    onFiltersChange({
                                        ...filters,
                                        contributor: undefined,
                                        space: undefined,
                                        creator: undefined,
                                        requestedReview: undefined,
                                        conversationsIssuesCluster: undefined,
                                    });
                                }}
                            />
                        </EmptyStateActions>
                    </>
                ) : filters?.status === api.ChangeRequestStatus.Open ? (
                    <Description>All good! No change requests to review.</Description>
                ) : filters?.status ? (
                    <Description>No {filters?.status} change requests to show.</Description>
                ) : (
                    <Description>No change requests to show.</Description>
                )}
            </EmptyState>
        </div>
    );
}
